<template>
  <div class="prepaid-package">
    <p
      class="prepaid-package__name"
      v-t="`packets.${user.serviceClassGroup}.frontpage_title`"
    ></p>
    <div class="box">
      <!-- Rajaton prepaid -->
      <div class="box__row" v-if="user.serviceClassGroup === 'rajaton'">
        <div class="box__column box__column--horizontal">
          <div class="box__content">
            <p class="smaller" v-t="'frontpage.saldo'"></p>
            <h3>
              <span class="bolder"
                >{{ formatCurrency(user.saldo, { includeEuro: false }) }} </span
              ><span class="euro">&euro;</span>
            </h3>
            <p class="smaller">
              {{ Math.floor(user.saldo / 0.89) }}
              {{ $tc('general.days', Math.floor(user.saldo / 0.89)) }}
            </p>
          </div>
          <div class="box__cta">
            <a
              class="button d-inline"
              :href="`${appInternalLinkUrl}/open/laturi`"
              v-t="'general.refill'"
            ></a>
          </div>
        </div>

        <div class="box__column box__column--horizontal">
          <div class="box__content">
            <p>
              <span v-if="this.state" v-t="'frontpage.pause_mode_set'" />
              <span v-else v-t="'frontpage.enable_pause_mode'" />
            </p>
            <p class="smaller" v-t="'frontpage.reconnect_fee'"></p>
          </div>
          <div class="box__cta">
            <div
              class="switch-toggle"
              :class="{ active: this.state }"
              @click="openModal"
            >
              <div class="switch-toggle__switch" :style="style"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- SuperPrepaid -->
      <div class="box__row" v-if="user.serviceClassGroup === 'super'">
        <div class="box__column box__column--horizontal">
          <div class="box__content">
            <p class="smaller" v-t="'frontpage.saldo'"></p>
            <h3>
              <span class="bolder"
                >{{ formatCurrency(user.saldo, { includeEuro: false }) }} </span
              ><span class="euro">&euro;</span>
            </h3>
          </div>
          <div class="box__cta">
            <a
              :href="`${appInternalLinkUrl}/open/laturi`"
              class="button d-inline"
              v-t="'general.refill'"
            ></a>
          </div>
        </div>
      </div>

      <div
        class="box__row"
        v-if="user.serviceClassGroup === 'super' && user.packet !== null"
      >
        <div class="box__column box__column--horizontal">
          <div class="box__content">
            <p class="smaller">{{ user.packet.duration }}</p>
            <h3>
              <span class="bolder"
                >{{ user.packet.durationCounter.days }}

                <span v-if="user.packet.id !== '1100'">
                  / {{ user.packet.durationCounter.maxDays }}
                </span>
              </span>
              <span class="min normal-text" v-t="'general.days_short'"></span>
            </h3>
          </div>
          <!-- <div class="box__cta">
            <a
              :href="`${appInternalLinkUrl}/open/laturi`"
              class="button button--white d-inline"
              v-t="'general.buy'"
            ></a>
          </div> -->
        </div>
      </div>

      <!-- DataPrepaid -->
      <div class="box__row" v-if="user.serviceClassGroup === 'data'">
        <div class="box__column box__column--vertical">
          <div class="box__content center">
            <p class="smaller">{{ user.packet.duration }}</p>
            <DataSlider :packet="user.packet" />
          </div>
          <div class="box__cta">
            <a
              :href="`${appInternalLinkUrl}/open/laturi`"
              class="button w-100 slim center"
              v-t="'general.refill'"
            ></a>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL -->
    <modal :show="this.showModal">
      <AlertIcon slot="icon" class="icon" />
      <h3 slot="header" v-t="'general.are_you_sure'"></h3>
      <p slot="body" v-t="'frontpage.reconnect_fee_info'"></p>
      <div
        slot="body"
        class="error-block"
        v-if="pauseError"
        v-t="`api_errors.${pauseError}`"
      ></div>
      <button slot="footer" @click="onClick" class="button button--alert w-100">
        <span v-if="!this.state" v-t="'frontpage.set_pause_mode'" />
        <span v-else v-t="'frontpage.unset_pause_mode'" />
      </button>
      <button
        slot="footer"
        @click="openModal"
        class="button button--white w-100"
        v-t="'general.cancel'"
      ></button>
    </modal>
  </div>
</template>

<script>
import DataSlider from './DataSlider';
import formatCurrency from '@/plugins/currency-formatter';
import Modal from './Modal';
import AlertIcon from '@/assets/svg/alert.svg?inline';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    DataSlider,
    Modal,
    AlertIcon,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      width: 100,
      state: false,
      position: 0,
      showModal: false,
      orientation: false,
    };
  },
  mounted() {
    this.toggle(this.user.pauseMode);
  },
  computed: {
    ...mapGetters('user', ['user']),
    ...mapState('user', ['pauseError']),
    style() {
      return {
        transform: `translateX(${this.pos_percentage})`,
      };
    },
    pos_percentage() {
      return `${(this.position / this.width) * 100}%`;
    },
  },
  watch: {
    position() {
      this.state = this.position >= 50;
    },
  },
  methods: {
    async onClick() {
      let success;
      if (this.user.pauseMode) {
        success = await this.$store.dispatch('user/disablePause');
      } else {
        success = await this.$store.dispatch('user/enablePause');
      }
      if (success) {
        this.toggle(!this.state);
        this.showModal = !this.showModal;
      }
      this.$store.dispatch('user/fetch', true);
    },
    toggle(state) {
      this.state = state;
      this.position = !state ? 0 : 100;
    },
    onClose() {
      this.showModal = this.showModal;
    },
    openModal() {
      this.showModal = !this.showModal;
    },
    classOrientation() {
      return {
        'box__column--horizontal': false,
        'box__column--vertical': true,
      };
    },
    formatCurrency,
  },
};
</script>

<style lang="scss" scoped>
$color-white: #fff;
$color-black: #000;
$color-success: #4cd964;
$color-orange: #ff7800;
$color-error: #e80c0c;

.prepaid-package {
  width: 100%;
  margin-top: 10px;

  h3,
  p {
    margin: 0;
  }

  &__name {
    color: $dark-gray;
    text-transform: uppercase;
    font-size: 12px;
  }

  .smaller {
    font-size: 14px;
  }

  .box {
    &__row {
      display: grid;
      grid-auto-rows: 1fr;
      grid-row-gap: 1px;
      height: 100%;
      margin-top: 10px;
    }

    &__column {
      display: flex;
      padding: 10px 20px;
      margin-bottom: 1px;
      background-color: $color-white;

      @include block-shadow();

      &--horizontal {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }

      &--vertical {
        flex-direction: column;
      }
    }

    &__content {
      &--data {
        text-align: center;

        .day {
          &--green {
            color: $color-success;
          }
          &--orange {
            color: $color-orange;
          }
          &--red {
            color: $color-error;
          }
        }
      }
    }
  }

  .switch-toggle {
    position: relative;
    width: 55px;
    height: 30px;
    display: inline-block;
    cursor: pointer;
    border: 2px solid $light-gray;
    border-radius: 30px;

    &__switch {
      position: relative;
      display: block;
      width: 26px;
      height: 26px;
      background-color: $color-white;
      box-shadow: 0, 2px, 2px rgba($color-black, 0.5);
      border: 1px solid $light-gray;
      border-radius: 100%;
      transition: all 0.3s ease-in 0s;
    }

    &.active {
      background: $color-success;
      border: 2px solid $color-success;
    }
  }

  .icon {
    width: 100%;
    height: 100%;
    g {
      fill: $color-error;
    }
  }
}
</style>
